import { useMemo } from 'react'

import { useCompanySlug } from '#/store/ducks/company'
import { useFarmSlug } from '#/store/ducks/farm'

import { PagesService } from './PagesService'
import { usePageConditions } from './usePageConditions'

export function usePages(): PagesService {
  const conditions = usePageConditions()
  const farmSlug = useFarmSlug()
  const companySlug = useCompanySlug()

  return useMemo(
    () =>
      new PagesService(conditions, {
        params: {
          ...(farmSlug ? { farm: farmSlug } : {}),
          ...(companySlug ? { company: companySlug } : {}),
        },
      }),
    [conditions, farmSlug, companySlug],
  )
}
